'use client'

import { urlForImage } from "@/sanity/lib/image"
import Image from "next/image"
import Link from "next/link"

interface ArticleRowProps {
	headline: string
	tag: string
	date: string
	url: string
	image?: any
}

export default function ArticleRow({headline, tag, date, url, image}:ArticleRowProps) {
	return (
		<Link href={url} className="relative site-grid items-center group border-t border-grey dark:border-grey-dark py-6 sm:py-8 md:py-12">
			<div className="col-span-1 sm:col-span-3 md:col-span-2 relative z-200 text-base leading-105 text-grey dark:text-grey-dark group-hover:text-black dark:group-hover:text-white">{tag}</div>
			<div className="mt-3 md:mt-0 col-span-full md:col-span-7 relative z-200 font-500 text-xl leading-105 text-black dark:text-white">
				{headline}
			</div>
			{image && (
				<Image
					className="absolute z-300 top-4 right-0 w-[25vw] h-auto rounded-[10px] pointer-events-none opacity-0 group-hover:opacity-100 mobile:hidden touch:hidden"
					src={urlForImage(image).width(720).url()}
					sizes='10vw'
					width={image?.asset?.metadata?.dimensions?.width}
					height={image?.asset?.metadata?.dimensions?.height}
					alt={headline}
					placeholder="blur"
					blurDataURL={image?.asset?.metadata?.lqip}
					quality={90}
				/>
			)}
		</Link>
	)
}